import styled from 'styled-components';

export const CommonWrapper = styled.div`
  margin: 0 auto; /* 가운데 정렬을 위한 margin 설정 */
  box-sizing: border-box;
  padding: ${({ padding }) => padding || '0 20px'};
  max-width: 640px;
  min-width: 310px;
  height: 100%;

  @media screen and (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const Background = styled.div`
  /* overflow-y: auto; */
  min-height: ${({ theme }) => `calc(100vh - ${theme.config.headerHeight})`};
  /* max-height: ${({ theme }) =>
    `calc(100vh - ${theme.config.headerHeight})`}; */
  width: 100%;
  height: 100%;
  background-color: ${(props) =>
    props.color || props.theme.colors.background.white};
`;
